export default "__VITE_ASSET__d976af03__$_?nuxt_component=async__"